/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {AlertNotification, AlertNotifications} from '@ion/core/src/types/entities';

// input selectors ...
const selectGridColumnState  = ({notifications: {grid}}) => grid?.columnState;
const selectModularSearch    = ({notifications: {search}}) => search;
const selectViewNotification = ({notifications: {view}}) => view || {};
const selectViewIsEditing    = state => selectViewNotification(state).isEditing;
const selectViewSelected     = state => selectViewNotification(state).selected;
const selectViewIsLoading    = state => selectViewNotification(state).loading;

// output selectors ...
export const notificationsGridColumnStateSelector = createDeepEqualSelector(
  selectGridColumnState, columnState => columnState
);

export const notificationsModularSearchSelector = createDeepEqualSelector(
  selectModularSearch, search => search
);

export const viewNotificationEventIsEditingSelector = createSelector(selectViewIsEditing,
  (isEditing: boolean): boolean => isEditing
);
export const viewNotificationEventIsLoadingSelector = createSelector(selectViewIsLoading,
  (loading: boolean): boolean => loading
);
export const viewNotificationEventSelectedSelector = createDeepEqualSelector(selectViewSelected,
  (selected: AlertNotification | AlertNotifications | null): AlertNotification | AlertNotifications | null => selected
);
